import { render, staticRenderFns } from "./CRI.vue?vue&type=template&id=b588ff3c&scoped=true&"
import script from "./CRI.vue?vue&type=script&lang=js&"
export * from "./CRI.vue?vue&type=script&lang=js&"
import style0 from "./CRI.vue?vue&type=style&index=0&id=b588ff3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b588ff3c",
  null
  
)

export default component.exports